import Separator_module_default from "./Separator.module.js";
import classNames from "classnames";
import { forwardRef, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import { useMergeRefs } from "@floating-ui/react";
import * as RadixSeparator from "@radix-ui/react-separator";
//#region src/components/Separator/Separator.tsx
var SPACING_CUSTOM_PROP = "--cpd-separator-spacing";
/**
* A separator component.
*/
var Separator = forwardRef(({ className, spacing, kind = "primary", ...props }, theirRef) => {
	const classes = classNames(Separator_module_default.separator, className);
	const ourRef = useRef(null);
	const ref = useMergeRefs([ourRef, theirRef]);
	useEffect(() => {
		const style = ourRef.current?.style;
		if (spacing) style?.setProperty(SPACING_CUSTOM_PROP, spacing);
		else style?.removeProperty(SPACING_CUSTOM_PROP);
	}, [spacing]);
	return /* @__PURE__ */ jsx(RadixSeparator.Root, {
		...props,
		className: classes,
		ref,
		"data-kind": kind
	});
});
Separator.displayName = "Separator";
//#endregion
export { Separator };

//# sourceMappingURL=Separator.js.map